if (!customElements.get('responsive-variant-option')) {
  customElements.define('responsive-variant-option', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.mode = 'desktop';
      this.onBreakpointChange = () => this.updateControl();
      this.breakpoint.addEventListener('change', this.onBreakpointChange);
      this.updateControl();
    }

    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.onBreakpointChange);
    }

    updateControl() {
      const mode = this.breakpoint.matches ? 'mobile' : 'desktop';
      if (mode === this.mode) return;
      const active = this.querySelector('[data-responsive-active]');
      const template = this.querySelector(`[data-responsive-${mode}]`);
      if (!active || !template) return;

      const previous = active.querySelector('select option:checked, input[type="radio"]:checked');
      const selectedId = previous?.dataset.optionValueId;
      const hadFocus = active.contains(document.activeElement);
      const fragment = template.content.cloneNode(true);
      const choices = Array.from(fragment.querySelectorAll('option, input[type="radio"]'));
      const selected = choices.find((choice) => choice.dataset.optionValueId === selectedId);

      if (selected) {
        choices.forEach((choice) => {
          const isSelected = choice === selected;
          if (choice.tagName === 'OPTION') {
            choice.selected = isSelected;
            if (isSelected) choice.setAttribute('selected', 'selected');
            else choice.removeAttribute('selected');
          } else {
            choice.checked = isSelected;
            choice.toggleAttribute('checked', isSelected);
          }
        });
      }

      active.replaceChildren(fragment);
      this.mode = mode;
      const control = active.querySelector('select, input[type="radio"]:checked');
      if (control) {
        const label = active.querySelector('[data-selected-value]');
        if (control.tagName === 'SELECT') {
          const swatch = label?.querySelector('.swatch');
          const option = control.selectedOptions[0];
          if (swatch && option) {
            const background = option.dataset.optionSwatchValue;
            swatch.style.setProperty('--swatch--background', background || 'unset');
            swatch.style.setProperty('--swatch-focal-point', option.dataset.optionSwatchFocalPoint || 'unset');
            swatch.classList.toggle('swatch--unavailable', !background);
          }
        } else if (label) {
          label.textContent = control.value;
        }
        if (hadFocus) control.focus({ preventScroll: true });
      }
    }
  });
}
